import {StatusLayerType} from '../settings.service';
import {TrackStyles} from './TrackStyles';

export class LayerTypeFilter {
  filterName: string;
  measurement: string;
  measurementUnits?: FilterSetting[];

  static coverageLayerTypeFilter(trackStyles: TrackStyles): LayerTypeFilter {
    return {
      filterName: StatusLayerType.COVERAGE,
      measurement: 'Passes',
      measurementUnits: [
        {
          number: '1',
          color: trackStyles.roadStatusCoverageLevel1.color,
          dashArray: trackStyles.roadStatusCoverageLevel1.dasharray,
        },
        {
          number: '2-4',
          color: trackStyles.roadStatusCoverageLevel2.color,
          dashArray: trackStyles.roadStatusCoverageLevel2.dasharray,
        },
        {
          number: '5-7',
          color: trackStyles.roadStatusCoverageLevel3.color,
          dashArray: trackStyles.roadStatusCoverageLevel3.dasharray,
        },
        {
          number: '8-10',
          color: trackStyles.roadStatusCoverageLevel4.color,
          dashArray: trackStyles.roadStatusCoverageLevel4.dasharray,
        },
        {
          number: '10+',
          color: trackStyles.roadStatusCoverageLevel5.color,
          dashArray: trackStyles.roadStatusCoverageLevel5.dasharray,
        },
      ],
    };
  }

  static currencyLayerTypeFilter(trackStyles: TrackStyles, timeUnit: number): LayerTypeFilter {
    return {
      filterName: StatusLayerType.CURRENCY,
      measurement: 'Time',
      measurementUnits: [
        {
          number: `< ${timeUnit} hr`,
          color: trackStyles.roadStatusCurrencyLevel1.color,
          dashArray: trackStyles.roadStatusCurrencyLevel1.dasharray,
        },
        {
          number: `${timeUnit}-${timeUnit * 2} hr`,
          color: trackStyles.roadStatusCurrencyLevel2.color,
          dashArray: trackStyles.roadStatusCurrencyLevel2.dasharray,
        },
        {
          number: `${timeUnit * 2}-${timeUnit * 3} hr`,
          color: trackStyles.roadStatusCurrencyLevel3.color,
          dashArray: trackStyles.roadStatusCurrencyLevel3.dasharray,
        },
        {
          number: `${timeUnit * 3}-${timeUnit * 4} hr`,
          color: trackStyles.roadStatusCurrencyLevel4.color,
          dashArray: trackStyles.roadStatusCurrencyLevel4.dasharray,
        },
        {
          number: `${timeUnit * 4}-${timeUnit * 12} hr`,
          color: trackStyles.roadStatusCurrencyLevel5.color,
          dashArray: trackStyles.roadStatusCurrencyLevel5.dasharray,
        },
      ],
    };
  }

  static gpsTracksLayerTypeFilter(trackStyles: TrackStyles): LayerTypeFilter {
    return {
      filterName: StatusLayerType.GPS_TRACKS,
      measurement: '',
      measurementUnits: [
        {
          number: 'Active',
          color: trackStyles.liveMapPlowLive.color,
          dashArray: trackStyles.liveMapPlowLive.dasharray,
        },
        {
          number: 'Recent',
          color: trackStyles.liveMapPlowInactive.color,
          dashArray: trackStyles.liveMapPlowInactive.dasharray,
        },
      ],
    };
  }

  static assignmentStatusLayerTypeFilter(trackStyles: TrackStyles): LayerTypeFilter {
    return {
      filterName: StatusLayerType.ASSIGNMENT_STATUS,
      measurement: '',
      measurementUnits: [
        {
          number: 'Serviced',
          color: trackStyles.assignmentStatusServiced.color,
          dashArray: trackStyles.assignmentStatusServiced.dasharray,
        },
        {
          number: 'In Progress',
          color: trackStyles.assignmentStatusInProgress.color,
          dashArray: trackStyles.assignmentStatusInProgress.dasharray,
        },
        {
          number: 'Not Serviced',
          color: trackStyles.assignmentStatusNotServiced.color,
          dashArray: trackStyles.assignmentStatusNotServiced.dasharray,
        },
      ],
    };
  }

  static routeStatusLayerTypeFilter(trackStyles: TrackStyles): LayerTypeFilter {
    return {
      filterName: StatusLayerType.ROUTE_STATUS,
      measurement: '',
      measurementUnits: [
        {
          number: 'Not Done',
          color: trackStyles.routeStatusNotDone.color,
          dashArray: trackStyles.routeStatusNotDone.dasharray,
        },
        {
          number: 'Done < 2h',
          color: trackStyles.routeStatusLevel1.color,
          dashArray: trackStyles.routeStatusLevel1.dasharray,
        },
        {
          number: 'Done 2-5h',
          color: trackStyles.routeStatusLevel2.color,
          dashArray: trackStyles.routeStatusLevel2.dasharray,
        },
        {
          number: 'Done 5-12h',
          color: trackStyles.routeStatusLevel3.color,
          dashArray: trackStyles.routeStatusLevel3.dasharray,
        },
      ],
    };
  }

  static copy(legendSettings: LayerTypeFilter): LayerTypeFilter {
    return JSON.parse(JSON.stringify(legendSettings));
  }
}

export interface FilterSetting {
  number: string;
  color: string;
  dashArray: number[];
}
